import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FetchTableLevelMessagesParams } from '../../api/fetchers/tableLevelMessages/fetcher';
import { fetchTableLevelMessages } from '../../api/fetchers/tableLevelMessages/fetcher';

interface FetchTableLevelMessagesActionParams extends FetchTableLevelMessagesParams {
  essential?: boolean;
}

export const fetchTableLevelMessagesAction = createAsyncThunk(
  'tableLevelMessages/fetchTableLevelMessages',
  (params: FetchTableLevelMessagesActionParams) => fetchTableLevelMessages(params)
);
